import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { getUserInfo, setUserInfo, removeAuthToken } from "../../utils/helper";

interface UserInfo {
  userId: string;
  email: string;
  fullName: string;
  profileImage?: string;
}

interface AuthState {
  user: UserInfo | null;
  isAuthenticated: boolean;
}

// Initialize state from localStorage
const userFromStorage = getUserInfo();
const initialState: AuthState = {
  user: userFromStorage as UserInfo | null,
  isAuthenticated: !!userFromStorage,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserInfo>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      // Persist to encrypted localStorage
      setUserInfo(action.payload);
    },
    updateUser: (state, action: PayloadAction<Partial<UserInfo>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
        // Persist to encrypted localStorage
        setUserInfo(state.user);
      }
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      // Clear localStorage
      removeAuthToken();
    },
  },
});

export const { setUser, updateUser, logout } = authSlice.actions;
export default authSlice.reducer;
